import Modifier from 'ember-modifier'
import { service } from '@ember/service'
import config from 'teacher-ui-client/config/environment'
import type AnalyticsService from 'teacher-ui-client/services/analytics'

interface Signature {
  Args: {
    Named: Record<PropertyKey, unknown>
    Positional: [string]
  }
  Element: HTMLElement
}

export class posthogEvent extends Modifier<Signature> {
  @service analytics!: AnalyticsService

  didSetup = false

  modify(
    element: Signature['Element'],
    [eventName]: Signature['Args']['Positional'],
    named: Signature['Args']['Named'],
  ) {
    if (!config.posthog.enabled) return

    if (this.didSetup) return
    this.didSetup = true

    element.addEventListener('click', () => {
      this.analytics.capture(eventName, named)
    })
  }
}
